import {detectLanguage} from "../api/translate";
import {persistentToastError} from "../util/ToastifyUtil";
import {useTranslationData} from "../TranslationContext";
import {useAuthData} from "../LoginContext";


export const useAutoDetect = () => {
    const { auth0IdToken, consumerId } = useAuthData();

    const {
        setIsDetectLanguageLoading,
        setLanguageFrom,
        setAutoTranslate,
        autoDetectLanguageEnabled,
        setAutoDetectLanguageEnabled
    } = useTranslationData();

    const autoDetectLang = async (text: string, autoTranslate?: boolean) => {
        try {
            setIsDetectLanguageLoading(true);
            const lang = await detectLanguage(text, auth0IdToken, consumerId);
            if (lang) {
                setLanguageFrom(lang);

                // once lang is detected, set autoDetectEnabled to false, avoid unnecessary detection calls
                setAutoDetectLanguageEnabled(false);

                // if needed, set autoTranslate to perform auto translate
                // TODO: refactor autoTranslate logic, this param should not be handled in autoDetectLang function,
                setAutoTranslate(autoTranslate || false);
            }
        } catch (e: any) {
            if (auth0IdToken === null) {
                persistentToastError(e.message);
            }
        } finally {
            setIsDetectLanguageLoading(false);
        }
    };

    return {
        autoDetectLang,
        autoDetectLanguageEnabled,
        setAutoDetectLanguageEnabled,
    };
}